import React from "react";
import { TextField } from "@mui/material";
import { Control, Controller } from "react-hook-form";

interface Props {
  control: Control<any, any>;
  fieldName: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  type?: "text" | "password" | "email" | "number" | "tel";
  maxValue?: number;
  length?: number;
  helperText?: string;
}

const FormTextField: React.FC<Props> = (props) => {
  const {
    control,
    fieldName,
    label,
    required,
    type,
    disabled,
    maxValue,
    length,
    helperText,
  } = props;

  const validationRules: Record<string, unknown> = {};

  if (required) {
    validationRules.required = {
      value: true,
      message: "Required",
    };
  }

  if (typeof length === "number") {
    validationRules.maxLength = {
      value: length,
      message: `Value must be ${length} digits`,
    };
    validationRules.minLength = {
      value: length,
      message: `Value must be ${length} digits`,
    };
  }

  if (typeof maxValue === "number") {
    validationRules.max = {
      value: maxValue,
      message: `Value cannot be more than ${maxValue}`,
    };
  }

  if (type === "email") {
    validationRules.pattern = {
      value:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
      message: "Enter a valid email address",
    };
  }

  return (
    <Controller
      name={fieldName}
      control={control}
      rules={validationRules}
      render={({
        field: { onChange, value },
        fieldState: { error },
        formState,
      }) => (
        <TextField
          fullWidth
          label={label}
          helperText={error ? error.message : helperText ?? null}
          error={!!error}
          onChange={onChange}
          value={value || ""}
          variant="outlined"
          type={type || "text"}
          disabled={disabled}
        />
      )}
    />
  );
};

export default FormTextField;
